import { DialogContent as NovaBaseDialogContent } from '@fme-nova/components'
import { DialogContent as MuiBaseDialogContent, DialogContentProps, styled } from '@mui/material'

import { createComponentWrapperWithRef } from '../../theme'
import { COLORS } from '../../theme/colors'
import { MsdkStyledComponent } from '../../utils'

const MuiDialogContent: MsdkStyledComponent<DialogContentProps> = styled(MuiBaseDialogContent)`
  padding: 0;
  border-bottom: 1px solid ${COLORS.divider};
  display: flex;
  flex-direction: column;
`

const NovaDialogContent: MsdkStyledComponent<DialogContentProps> = styled(NovaBaseDialogContent)`
  padding: 0;
  display: flex;
  flex-direction: column;
`

export const DialogContent = createComponentWrapperWithRef<DialogContentProps>(
  {
    mui: MuiDialogContent,
    nova: NovaDialogContent,
  },
  'DialogContent',
)
